import { makeAutoObservable } from 'mobx';
import appApi from '../api/app-api';
import {
  AdminProfile,
  ProfessorProfile,
  UserProfile,
} from '../api/types/settings/settings-all';
import { UserType } from '../api/types/user/user-type';
import globalSettingsStores from './settings-stores';
import globalConfigStore from './global-config-store';

const USER_ROLE_STORAGE_KEY = 'user_role';

class GlobalUserProfile {
  userProfile: UserProfile | null = null;
  userType: UserType | null = null; // Separate property for user type (can be loaded from cache)
  isFullProfileLoaded = false; // Flag to indicate if full profile is loaded from API

  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
    // Load cached user profile on initialization
    this.loadCachedUserRole();
  }

  // Load user role from localStorage
  private loadCachedUserRole() {
    try {
      const cachedRole = localStorage.getItem(USER_ROLE_STORAGE_KEY);
      if (cachedRole) {
        // Store cached role in the userType property
        this.userType = cachedRole as UserType;
        this.isFullProfileLoaded = false; // Only role is loaded, not full profile
      }
    } catch (error) {
      console.error('Error loading cached user role:', error);
    }
  }

  // Save user role to localStorage
  private saveCachedUserRole(userType: UserType) {
    try {
      localStorage.setItem(USER_ROLE_STORAGE_KEY, userType);
    } catch (error) {
      console.error('Error saving user role to localStorage:', error);
    }
  }

  // Clear cached user role (useful for logout)
  public clearCachedUserRole() {
    try {
      localStorage.removeItem(USER_ROLE_STORAGE_KEY);
      this.userProfile = null;
      this.userType = null;
      this.isFullProfileLoaded = false;
    } catch (error) {
      console.error('Error clearing user role from localStorage:', error);
    }
  }

  async getUserProfile() {
    const res = await appApi.getHome2();
    this.userProfile = res.data.body;
    this.userType = res.data.body.userType; // Store userType separately
    this.isFullProfileLoaded = true; // Mark that full profile is now loaded
    globalConfigStore.baseFileUrl = res.data.body.baseFileUrl;

    // Save user role to localStorage
    this.saveCachedUserRole(res.data.body.userType);

    switch (res.data.body.userType) {
      case UserType.LECTURER:
        globalSettingsStores.assignmentTypes = (
          res.data.body.profile as ProfessorProfile
        ).assignmentTypes;
        break;
      case UserType.ADMINISTRATION:
        const adminProfile: AdminProfile = res.data.body
          .profile as AdminProfile;
        globalSettingsStores.fetchSetting(adminProfile.settings);
        break;
      case UserType.STUDENT:
        break;
    }
  }
}

const globalUserProfile = new GlobalUserProfile();
export default globalUserProfile;
